import * as CommonConstants from "utilities/CommonConstants";

// config取得キー
export const CAMPUS_HOLIDAY = `holidays`;
export const CALENDAR_LOCALE = `calendarLocale`;
export const CALENDAR_DAYS_OF_WEEK = `calendarDaysOfWeek`;
export const CALENDAR_SLOTDURATION = `calendarSlotduration`;
export const CALENDAR_START_TIME_AM = `calendarStartTimeAm`;
export const CALENDAR_END_TIME_AM = `calendarEndTimeAm`;
export const CALENDAR_START_TIME_PM = `calendarStartTimePm`;
export const CALENDAR_END_TIME_PM = `calendarEndTimePm`;
export const BOOKING_START_TIME = `bookingStartTime`;
export const BOOKING_END_TIME = `bookingEndTime`;
export const BOOKING_BOOKINGABLE_DAYS = `bookingBookingableDays`;
export const BOOKING_BOOKINGABLE_LIMIT = `bookingBookingableLimit`;
export const BOOKING_INTERVAL_LIQUID_WASTE = `bookingIntervalLiquidWaste`;
export const BOOKING_INTERVAL_DEPOSIT = `bookingIntervalDeposit`;
export const BOOKING_DEADLINE = `bookingDeadline`;
export const BOOKING_BOOKINGABLE_DAYS_OF_WEEK = `bookingBookingableDaysOfWeek`;
export const EMAIL_DOMAIN_LIST = `emailDomainList`;
export const HP_LINK = `hpLink`;
export const SOLVENT_LINK = `solventLink`;

/**
 * config取得クラス
 */
export class ConfigGetter {
    /**
     * sessionStrageで管理しているconfigから指定の値を取得する
     * @param key 取得対象のキー
     * @return 指定されたキーに紐づく値
     */
    static get = (key: string): any => {
        const config = sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG);
        let value = ``;
        if (typeof config === `string`) {
            const arr = JSON.parse(config);
            value = arr[key];
        }
        return value;
    };

    static getNum = (key: string): number => {
        const config = sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG);
        let value = ``;
        if (typeof config === `string`) {
            const arr = JSON.parse(config);
            value = arr[key];
            if (typeof value === `number`) {
                return parseInt(value);
            }
        }
        return 0;
    };

    static getList = (key: string): any[] => {
        const config = sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG);
        let value = [];
        if (typeof config === `string`) {
            const arr = JSON.parse(config);
            value = arr[key];
        }
        return value;
    };
}
